
import {app}from '../../BD/Config'
import { GoogleAuthProvider,  getAuth,  signInWithPopup,  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,  sendPasswordResetEmail,  signOut} from "firebase/auth";
import { getFirestore, setDoc,  getDoc,doc,  collection,  where,  addDoc,serverTimestamp,Timestamp, FieldValue} from "firebase/firestore";

/*Configuracion del servidor*/
const auth = getAuth(app); /*Conectar a Firebase autentication*/ 
const db = getFirestore(app);/*Conectar a la BD*/ 
const googleProvider = new GoogleAuthProvider();

const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    
    const myUser = doc(db, "Users", user.uid);
    const docSnapshot = await getDoc(myUser);

    if (docSnapshot.exists()) {
      const userData = docSnapshot.data();
      // El documento existe y se ha obtenido la información
      console.log(userData);
    } else {
      // El documento no existe
      console.log("El documento no existe y se creará");
      await setDoc(myUser, {
        uid: user.uid,
        nombre: user.displayName,
        apellidoPa: "",
        apellidoMa: "",
        authProvider: "gmail",
        email: user.email,
        autorizado: false,
        rol: {},
        addRec: serverTimestamp()
      }, { merge: true });
    }
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

/*3.-Registrar con Email y Password*/
const registerWithEmailAndPassword = async (email, password) => {
  try {
    const authResult = await createUserWithEmailAndPassword(auth, email, password);
    const user = authResult.user;
    await  setDoc(collection(db, "Users", user.uid), {
      uid: user.uid,
      nombre:user.displayName,
      apellidoPa:"",
      apellidoMa:"",
      authProvider: "local",
      email:user.email,
      autorizado:false,
      rol:{},
      addRec:serverTimestamp()
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
/*4.-Reiniciar contraseña */
const sendPasswordReset = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};
/*5.-Desloguear*/
const logout = () => {
  signOut(auth);
};

export {
  auth,
  db,
  signInWithGoogle,
 // logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  sendPasswordReset,
  logout
};